import React from 'react'

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            displayInfo: { display: '' },
        }
    }
    onClose = () => {
        this.setState({ displayInfo: { display: 'none' } })
        this.props.onLogin()
    }

    onLogin = () => {
        window.location.href = process.env.REACT_APP_SSO_URL
    }

    render() {
        return (
            <table id="lyrPop" className="bgdark" style={this.state.displayInfo}>
                <tbody>
                    <tr>
                        <td>
                            <div className="PopMain artPop">
                                <strong>로그인후 이용 가능합니다.</strong>
                                <div className="popDefBtns">
                                    <button className="icon-X_close" onClick={this.onClose} />
                                    <button className="styPBg" onClick={this.onClose}>
                                        취소
                                    </button>
                                    <button className="confBtn" onClick={this.onLogin}>
                                        확인
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }
}

export default Login



// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/login.js